import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Breadcrumbs from '../components/Breadcrumbs/Breadcrumbs';
import Chapters from '../components/DrawerAccordion/Chapters';
import Wrapper from '../components/Wrapper/Wrapper';
import db from '../db.json'
import styles from './Rzzj.module.css'

const data = Object.values(db);

const Rrzj = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Wrapper>
            <Helmet>
                <title>Referenční rámec</title>
            </Helmet>
            <Breadcrumbs />
            <div className={styles.accordionWrapper}>
                <h2 className={styles.headingTop}>Obsah Referenčního rámce pro znakové jazyky</h2>
                <Chapters data={data} />
            </div>
        </Wrapper>
    )
}

export default Rrzj;